// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__a6JVq","image":"styles_image__pFoyi","link":"styles_link__3V_wv"};